import { DataNode } from "graphql/types"
import { useStoreState } from "hooks/storeHooks"
import { deepEqual } from "utils/deepEqual"

export const useDataNodeChanged = () => {
  const textBlocks = useStoreState((state) => state.textBlocks)

  const hasDataNodeChanged = (dataNode: DataNode): boolean => {
    if (!dataNode.originalTextblockId || dataNode.originalTextBlockDataNodeNo === undefined) {
      return false
    }

    const textBlock = textBlocks.find((tb) => tb.id === dataNode.originalTextblockId)
    if (!textBlock || dataNode.originalTextBlockDataNodeNo === null) {
      return false
    }

    const originalDataNode = textBlock.block[dataNode.originalTextBlockDataNodeNo]
    if (!originalDataNode) {
      return false
    }

    // Compare relevant fields based on dataType
    if (dataNode.dataType !== originalDataNode.dataType) {
      return true
    }

    switch (dataNode.dataType) {
      case "TEXT":
        return dataNode.text !== originalDataNode.text
      case "TABLE":
        return (
          dataNode.tableCaption !== originalDataNode.tableCaption ||
          !deepEqual(dataNode.tableHeader, originalDataNode.tableHeader) ||
          !deepEqual(dataNode.tableBody, originalDataNode.tableBody)
        )
      case "IMAGE":
        return (
          !deepEqual(dataNode.image, originalDataNode.image) ||
          !deepEqual(dataNode.imageCaption, originalDataNode.imageCaption)
        )
      default:
        return false
    }
  }

  return { hasDataNodeChanged }
}
